export default {
  "product": {
    "product_info": "Product info",
    "trade_name": "Product name"
  }
}